import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import {
  VARIANTS_DOMAIN,
  VARIANTS_KEY,
  VARIANTS_PATH
} from 'modules/variant/redux/state'
import { REDUX_ACTION_PREFIX } from 'modules/redux/constants'
import loadReduxAction from 'modules/redux/actions/load'
import logUtil from 'utils/log'
import getEndpointLoadFromUrlProductActionUtil from 'modules/product/redux/actions/load-from-url/utils/get-endpoint'
import isProductUrlLocationUtil from 'utils/location/is-product-url'
import getEndpointLoadRelatedProductSelect from 'modules/variant/redux/actions/load-related-products/selectors/get-endpoint'

/**
 * @param {loadFromUrlProductActionProps} props
 */
export default function loadRelatedProducts (props) {
  return async (dispatch, getState) => {
    const logLabel = 'loadRelatedProducts'

    const isProductUrl = isProductUrlLocationUtil()

    let query = {
      page_size: isProductUrl ? 12 : 48
    }
    if (
      props?.isJustDroppedSlider &&
      props?.isFullSize
    ) {
      query = {
        ...query,
        justDropped: true
      }
    }

    const relatedProductEndpoint = getEndpointLoadRelatedProductSelect(getState())

    logUtil(logLabel).debug('[start] props=', props)

    const key = VARIANTS_KEY.RELATED_PRODUCTS
    const action = getActionStrReduxUtil(
      REDUX_ACTION_PREFIX.LOAD,
      VARIANTS_DOMAIN,
      key
    )

    const path = VARIANTS_PATH[key]
    const endpoint = getEndpointLoadFromUrlProductActionUtil({
      ...props,
      endpoint: relatedProductEndpoint
    })

    window?.initProductCardLikes?.()

    return dispatch(
      loadReduxAction({
        action,
        path,
        logLabel,
        endpoint,
        query
      })
    )
  }
}
